import { ANALYTICS_METADATA } from "fond/constants";
import { getItem, setItem } from "fond/utils/localStorage";

export const setAnalyticsItem = <T>(name: string, value: T) => {
  setItem(ANALYTICS_METADATA, { ...getItem(ANALYTICS_METADATA), [name]: value });
};

export const getAnalyticsItem = <T = string>(name: string): T | undefined => {
  const item = getItem(ANALYTICS_METADATA);
  if (typeof item === "object" && Object.hasOwn(item, name)) {
    return item[name];
  }
  return undefined;
};

export const clearAnalyticsStorage = () => {
  window.localStorage.removeItem(ANALYTICS_METADATA);
};
